import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { IconSet } from '../../../../atoms/mdt-iconset/index.js';
import { themeUpdate } from '../../../../../actions/MeActions.js';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { isEmpty } from 'lodash';
import './themeSelector.css';

const ThemeSelector = (props) => {
    const MDTSetting = window.MDTSetting;
    const dropdownItems = MDTSetting.themes;
    const defaultTheme = MDTSetting.features.defaultTheme === '#{defaultTheme}' ? 'electric' : MDTSetting.features.defaultTheme;
        
    const [selectedTheme, setSelectedTheme] = useState(MDTSetting.themes.find((element) => element.name= defaultTheme));

    const [isDropDownOpen, setDropDownOpen] = useState(false);

    const toggle = () => {
        setDropDownOpen(!isDropDownOpen);
    }

    useEffect(() => {
        if(dropdownItems.length) {
            const selectedTheme = dropdownItems.find((i) => i.name === defaultTheme.toLowerCase());

            setSelectedTheme(selectedTheme);
            props.getThemeChange(selectedTheme.id);
            addThemeClass(selectedTheme.id);
        }
    }, []);

    const changeValue = (themeId) => {
        const selectedObj = dropdownItems.find((theme) => theme.id === themeId);
        setSelectedTheme(selectedObj);
        props.getThemeChange(themeId);
        addThemeClass(themeId);
    }

    const addThemeClass = (themeId) => {
        dropdownItems.map((ele) => {
            document.body.classList.remove(ele.id);
        });
        document.body.classList.add(themeId);
    }

    return (<div className='theme-selector'>
        <Dropdown isOpen={isDropDownOpen} toggle={toggle}>
            <DropdownToggle caret>
                <span
                    className='body2 p-active display-name pr-5'>
                    <IconSet name="admin_cog_wheel" />{' '}
                    <span
                        className='name body2 p-active d-none d-sm-block'>
                        {selectedTheme.name}
                    </span>
                </span>
            </DropdownToggle>
            {!isEmpty(dropdownItems) && (
                <DropdownMenu>

                    {
                        <div key={`theme-active`}>
                            <DropdownItem divider />
                            <DropdownItem
                                className="dropdown-itemSelected"
                                onClick={() => changeValue(selectedTheme.id)}
                            >
                                <div className="body2 p-active text-capitalize">{selectedTheme.name}</div>
                            </DropdownItem>
                            <DropdownItem divider />
                        </div>
                    }

                    {dropdownItems.map((theme, index, arr) => {
                        return theme.id !== selectedTheme.id ? (
                            <div
                                key={`theme-${index}`}
                                data-test={`theme-${index}`}
                                data-locale={theme.id}
                            >
                                <DropdownItem onClick={() => changeValue(theme.id)}>
                                    <div className="body2 p-active text-capitalize">{theme.name}</div>
                                </DropdownItem>
                                {index < arr.length - 1 && <DropdownItem divider />}
                            </div>
                        ) : null;
                    })}
                </DropdownMenu>
            )}
        </Dropdown>
    </div>
    );
}

const mapDispatchToProps = (dispatch) => {
    return {
        getThemeChange: (theme) => dispatch(themeUpdate(theme)),
    };
};

export default connect(null, mapDispatchToProps)(ThemeSelector);
